import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
import { BackendService } from '../../../shared/services/backend.service';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
  animations: [fadeInLeftOnEnterAnimation()],
})
export class ContactUsComponent {
  private backendSrvc_: BackendService = inject(BackendService);
  contactForm: FormGroup;
  submitted = false;
  isLoading = false;
  successMessage: string | null = null;
  errorMessage: string | null = null;

  constructor(private fb: FormBuilder) {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required, Validators.minLength(5)]],
      message: ['', [Validators.required, Validators.minLength(10)]],
    });
  }

  get name() {
    return this.contactForm.get('name') as FormControl;
  }

  get email() {
    return this.contactForm.get('email') as FormControl;
  }

  get subject() {
    return this.contactForm.get('subject') as FormControl;
  }

  get message() {
    return this.contactForm.get('message') as FormControl;
  }

  dismissMessages() {
    this.successMessage = null;
    this.errorMessage = null;
  }

  onSubmit() {
    this.submitted = true;
    this.dismissMessages();
    if (this.contactForm.valid) {
      this.isLoading = true;
      const formData = { ...this.contactForm.value, created_at: new Date() };

      this.backendSrvc_
        .addGetInTouchDetails(formData)
        .then(() => {
          this.successMessage = 'Your message has been sent successfully!';
          this.contactForm.reset();
          this.submitted = false;
        })
        .catch((error) => {
          console.error('Error submitting form:', error);
          this.errorMessage =
            'An error occurred while sending your message. Please try again.';
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
